export default __webpack_public_path__ + "static/media/nci-logo-full.07e4f890.svg";